import EmptyView from "common/Empty/EmptyView";
import { typography } from "@shared/common/Themes/typography";
import { EmptyStatesType } from "common/Icons/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface ChartEmptyProps {
  isSmallChart?: boolean;
}

const ChartEmpty = ({ isSmallChart }: ChartEmptyProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);
  return (
    <EmptyView
      iconKey={EmptyStatesType.Graph}
      title={t("empty.no_data_collected")}
      iconWidth={isSmallChart ? 60 : 90}
      style={isSmallChart ? { padding: "12px 0" } : undefined}
      titleStyle={
        isSmallChart
          ? {
              fontSize: typography.fontSizes.M,
              marginTop: 0,
            }
          : undefined
      }
    />
  );
};

export default ChartEmpty;
